import { BULLJSJOBNAMES, BULLJSQUEUENAMES } from '@gtpl/shared-models/common-models';
import { Process, Processor, OnQueueEvent, BullQueueEvents, InjectQueue } from '@nestjs/bull';
import { Job, Queue } from 'bull';
import { PinoLogger } from 'nestjs-pino';
import { jobConfigs } from '../../../../config';

@Processor(BULLJSQUEUENAMES.SAMPLE_JOB)
export class WarehouseSampleJobProcessor {
  constructor(
    // private logger: PinoLogger,
    
  ) { }

  @Process({name:BULLJSJOBNAMES.SAMPLE_JOB, concurrency:5})
  async warehouseSampleJobJob(job: Job) {
    try {
      console.log('its working');
      console.log(job.data);
      return true;
      return "Job completed successfully";
    } catch (error) {
      throw new Error(error);
    }
  }


  @OnQueueEvent(BullQueueEvents.ERROR)
  onError(job: Job, error: Error) {
  }

  @OnQueueEvent(BullQueueEvents.FAILED)
  onFailed(job: Job, error: Error) {
  }

  @OnQueueEvent(BullQueueEvents.COMPLETED)
  onCompleted(job: Job) {
    job.progress(100);
  }

}
